import 'intl';

import ee from './ee';
import en from './en';
import es from './es';
import lt from './lt';
import lv from './lv';
import pl from './pl';
import ru from './ru';

// import { addLocaleData } from 'react-intl';

// Adding intl polifill for browser which do not support it yet
// const areIntlLocalesSupported = require('intl-locales-supported');
// const localesMyAppSupports = ['lt'];
// ['ee', 'en', 'es', 'lt', 'lv', 'pl', 'ru'];
if (global.Intl) {
  // // Determine if the built-in `Intl` has the locale data we need.
  // if (!areIntlLocalesSupported(localesMyAppSupports)) {
  //   // `Intl` exists, but it doesn't have the data we need, so load the
  //   // polyfill and patch the constructors we need with the polyfill's.
  //   const intlPolyfill = require('intl');
  //   Intl.NumberFormat = intlPolyfill.NumberFormat;
  //   Intl.DateTimeFormat = intlPolyfill.DateTimeFormat;
  // }
} else {
  // No `Intl`, so use and load the polyfill.
  global.Intl = require('intl');
}

// import 'intl/locale-data/jsonp/ee';
// import 'intl/locale-data/jsonp/en';
// import 'intl/locale-data/jsonp/es';
// import 'intl/locale-data/jsonp/lt';
// import 'intl/locale-data/jsonp/lv';
// import 'intl/locale-data/jsonp/pl';
// import 'intl/locale-data/jsonp/ru';

export default function loadMessages(userLanguage: string) {
  switch (userLanguage) {
    case 'EE':
      return ee;
    case 'EN':
      return en;
    case 'ES':
      return es;
    case 'LV':
      return lv;
    case 'PL':
      return pl;
    case 'RU':
      return ru;
    case 'LT':
    default:
      return lt;
  }
}
